(function($, App, Utils, Components){
  'use strict';

  const logger = new Logger("DataFile");

  Components.create('DataFile', {

    Selectors: {
      Main: '.js-input-file'
    },

    Events: {
      FileUploaded: 'files:uploaded',
    },

    size: 0,

    bindEvents: function() {
      Components.DataFile.$MainSelector.on('change', function (e) {
        let self = $(this);
        let $parent = self.closest('.js-input-file-container');
        let $placeholder = $parent.find('.js-placeholder');
        let $sizeText = $parent.siblings('.js-size');
        let placeholderText = $placeholder.text();
        let sizeText = $sizeText.data('fileSizeMessage');
        let errorText = $sizeText.data('fileSizeError');
        let maxFileSize = $sizeText.data('maxFileSize');

        let file = e.target.files[0];
        if (file) {
          let tempSize = (file.size / 1024) / 1024;

          if (tempSize > maxFileSize) {
            $parent.addClass('error');
            $sizeText.addClass('error');
            $sizeText.text(errorText);
            return;
          }

          $parent.removeClass('error');
          $sizeText.removeClass('error');

          Components.DataFile.size = `${tempSize.toFixed(2)}mb`;
          placeholderText = file.name;
        }
        $placeholder.text(placeholderText);
        $sizeText.text(sizeText + ' ~' + Components.DataFile.size);


        Components.trigger(Components.DataFile.Events.FileUploaded, [file])
      });
    },


    init: function() {
      Components.DataFile.$MainSelector = $(Components.DataFile.Selectors.Main);
      this.bindEvents();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
